import React from "react"
import NavLink from "../NavLink"
import CurrencyContext from "../../context/CurrencyContext"
import Pricing from "../ui/Pricing"
import { useStaticQuery, graphql } from "gatsby"

const StaticHostingBlock = () => {
  const allData = useStaticQuery(graphql`
    query {
      allProductsJson(filter: { pid: { eq: 71 } }) {
        edges {
          node {
            pid
            name
            description
            pricing {
              INR {
                prefix
                suffix
                monthly
                annually
              }
              MYR {
                prefix
                suffix
                monthly
                annually
              }
              SGD {
                prefix
                suffix
                monthly
                annually
              }
              USD {
                prefix
                suffix
                monthly
                annually
              }
              GBP {
                prefix
                suffix
                monthly
                annually
              }
            }
          }
        }
      }
    }
  `)
  const data = allData.allProductsJson.edges
  return (
    <div className="col-12 col-md-4 mb-3 mb-lg-0">
      <div className="card position-relative">
        <div className="card-body ">
          <h3 className="card-title">Static Web Hosting</h3>
          <div className="small-text">
          Free hosting available with every Domain Registration
          </div>
          <div className="card-text">
            <div className="fw-bolder">Starting from</div>
            <div className="fs-32 fw-bolder">
              <CurrencyContext.Consumer>
                {(context) => {
                  return (
                    <>
                      {data.map((item, index) => (
                        <Pricing
                          key={index}
                          CurrencyPrefix={item.node.pricing}
                          pricing={item.node.pricing}
                          productID={item.node.pid}
                        />
                      ))}
                    </>
                  )
                }}
              </CurrencyContext.Consumer>
            </div>
          </div>
          <NavLink
            to="/hosting/static-linux-web-hosting/"
            className="stretched-link btn"
          >
            Static Hosting
            <i className="bi bi-arrow-right float-end"></i>
          </NavLink>
        </div>

        <div className="d-inline-block w-auto card card-body shadow rounded-3 position-absolute end-0 top-0 p-3 me-lg-n3 me-xxl-n7 mt-n5 d-none d-sm-block">
					<img src="/img/svg/trustpilot.svg" className="h-20px mb-2" alt="Client-img"/>
					<div className="d-flex align-items-center">
						<img src="/img/svg/stars-5.svg"  className="h-20px mb-0" alt="rating-img"/>
						<h6 className="fs-16 fw-bold ms-1 mb-0">4.7/5.0</h6>
					</div>
					<p className="small mb-0 mt-2">Reviewed by 38 users</p>
				</div>
      </div>
    </div>
  )
}
export default StaticHostingBlock
